import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { KeyboardComponent } from '../keyboard/keyboard.component';

@Component({
  selector: 'kiosk-numeric-keyboard',
  templateUrl: './numeric-keyboard.component.html',
  styleUrls: ['./numeric-keyboard.component.scss']
})
export class NumericKeyboardComponent extends KeyboardComponent { 
  numericKeyboardButtons = [1,2,3,4,5,6,7,8,9]; 
}
